define('SageDotCom/Components/Content/ContentFilterTabset',["jquery"],
    function ($) {
        function ContentFilterTabset(scope) {
            var contentFilter = $(scope);
            var mainSelector = contentFilter.find(".content-filter__select--main");
            var secondarySelector = contentFilter.find(".content-filter__select--secondary");
            var hasSecondarySelector = secondarySelector.length > 0;
            var results = contentFilter.find("[data-filter-results]");
            var items = results.find("[data-filter-item]");

            // Preserve the original options so they can be restored
            var originalSecondaryOptions = secondarySelector.find("option").clone();
            var initialSecondaryValue = hasSecondarySelector
                ? normalise(secondarySelector.val())
                : "";

            function normalise(value) {
                return $.trim(value || "").toLowerCase();
            }

            function getFilterValues(value) {
                var values = [];
                var parts = (value || "").split(",");
                var i;
                var part;

                for (i = 0; i < parts.length; i++) {
                    part = normalise(parts[i]);

                    if (part !== "") {
                        values.push(part);
                    }
                }

                return values;
            }

            function containsFilterValue(values, selectedValue) {
                var i;

                for (i = 0; i < values.length; i++) {
                    if (values[i] === selectedValue) {
                        return true;
                    }
                }

                return false;
            }

            function updateSecondaryOptions(preserveDefault) {
                if (!hasSecondarySelector) {
                    return;
                }

                var selectedMain = normalise(mainSelector.val());
                var availableValues = {};
                var hasEmptySecondary = false;

                // Find secondary values based on items matching the primary filter
                items.each(function () {
                    var item = $(this);
                    var mainValues = getFilterValues(
                        item.attr("data-filter-main")
                    );
                    var secondaryValues = getFilterValues(
                        item.attr("data-filter-secondary")
                    );

                    var mainMatches = containsFilterValue(
                        mainValues,
                        selectedMain
                    );

                    if (mainMatches) {
                        if (secondaryValues.length === 0) {
                            hasEmptySecondary = true;
                        }

                        $.each(secondaryValues, function (index, value) {
                            availableValues[value] = true;
                        });
                    }
                });

                // Rebuild the dropdown from the original options
                secondarySelector.empty();

                originalSecondaryOptions.each(function () {
                    var option = $(this);
                    var value = normalise(option.val());
                    var isAvailable;

                    // Always display the placeholder option, i.e. default
                    if (value === "") {
                        secondarySelector.append(option.clone());
                        return;
                    }

                    // "*" matches items with no secondary value i.e default items
                    if (value === "*") {
                        isAvailable = hasEmptySecondary;
                    } else {
                        isAvailable = availableValues[value] === true;
                    }

                    if (isAvailable) {
                        secondarySelector.append(option.clone());
                    }
                });

                // On initialisation, preserve the configured secondary default if it remains available
                if (preserveDefault && initialSecondaryValue !== "*") {
                    var defaultOptionExists = false;

                    secondarySelector.find("option").each(function () {
                        if (normalise($(this).val()) === initialSecondaryValue) {
                            defaultOptionExists = true;
                            return false;
                        }
                    });

                    if (defaultOptionExists) {
                        secondarySelector.val(initialSecondaryValue);
                        return;
                    }
                }

                // Otherwise, reset to the default
                secondarySelector.prop("selectedIndex", 0);
            }

            function updateResults() {
                var selectedMain = normalise(mainSelector.val());
                var selectedSecondary = hasSecondarySelector
                    ? normalise(secondarySelector.val())
                    : "";

                items.each(function () {
                    var item = $(this);
                    var mainValues = getFilterValues(
                        item.attr("data-filter-main")
                    );
                    var secondaryValues = getFilterValues(
                        item.attr("data-filter-secondary")
                    );

                    var mainMatches = containsFilterValue(
                        mainValues,
                        selectedMain
                    );

                    var secondaryMatches;

                    if (!hasSecondarySelector) {
                        secondaryMatches = true;
                    } else if (
                        selectedSecondary === "" ||
                        selectedSecondary === "*"
                    ) {
                        // Main selected, secondary unselected:
                        // show only items without a secondary filter
                        secondaryMatches = secondaryValues.length === 0;
                    } else {
                        // Both filters selected:
                        // the item must match the secondary value
                        secondaryMatches = containsFilterValue(
                            secondaryValues,
                            selectedSecondary
                        );
                    }

                    item.prop(
                        "hidden",
                        !(mainMatches && secondaryMatches)
                    );
                });
            }

            // When the primary changes, rebuild secondary options and reset
            // the secondary selection to its deffault placeholder
            mainSelector.on("change", function () {
                updateSecondaryOptions(false);
                updateResults();
            });

            // Secondary changes only require the results to be updated
            secondarySelector.on("change", updateResults);

            // Initialise options while preserving a valid configured default
            updateSecondaryOptions(true);
            updateResults();
        }

        ContentFilterTabset.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new ContentFilterTabset(args.scope);
        };

        return ContentFilterTabset;
    });

